import {
  PREGUNTAS_FRECUENTES_HAS_ERRORED,
  PREGUNTAS_FRECUENTES_IS_LOADING,
  SET_PREGUNTAS_FRECUENTES
} from "../actions/aPreguntasFrecuentes";

const initialState = {
  preguntasFrecuentesIsLoading: false,
  preguntasFrecuentesHasError: false,
  PreguntasFrecuentes: [],
};

const datosPreguntasFrecuentes = (state = initialState, action) => {
  switch (action.type) {
    case PREGUNTAS_FRECUENTES_HAS_ERRORED:
      return {
        ...state,
        preguntasFrecuentesIsLoading: false,
        preguntasFrecuentesHasError: true,
      };

    case PREGUNTAS_FRECUENTES_IS_LOADING:
      return {
        ...state,
        preguntasFrecuentesIsLoading: true,
        preguntasFrecuentesHasError: false,
      };

    case SET_PREGUNTAS_FRECUENTES:
      return {
        ...state,
        PreguntasFrecuentes: action.payload,
        preguntasFrecuentesIsLoading: false,
        preguntasFrecuentesHasError: false,
      };
    default:
      return state;
  }
};

export default datosPreguntasFrecuentes;

